import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "trigger"];
  static values = { defaultSelected: String }

  connect() {
    this.triggerTargets.forEach((triggerTarget) => {
      if (triggerTarget.getAttribute('value') === this.defaultSelectedValue) {
        triggerTarget.checked = true;
      }
    })
    this.#switchContent(this.defaultSelectedValue);
  }

  toggle(event) {
    this.#switchContent(event.target.value);
  }

  #switchContent(identifier) {
    this.contentTargets.forEach((contentTarget) => {
      if (contentTarget.getAttribute('id') === identifier) {
        contentTarget.classList.remove('hide');
      } else {
        contentTarget.classList.add('hide');
      }
    })
  }
}
